import { isEmpty} from "lodash";

export default {
    methods: {
        genericHelperIsSet(element) {
            return ! (typeof element === 'undefined' || element === null || element === '' || ! element || isEmpty(element));
        }
    }
}
